import { getDateWithSpecificFormat } from '../../../../data-transform';
import { getStatusDescriptionFromStatusValue, getCountryNameByCountryCode, getOrderTypeText } from '../../../../../utils/utility';

const revitalizeHPPricesPendingOptions = [
    { id: "REQUESTED", label: "Requested" }
];

export default function directCustomerCTInitialQuotesColumnsSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    config.data.forEach((quote, index) => {
        let row = [];
        const rowId = quote.quoteId;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            const columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;

            let columnValue = null;
            let linkDestination = null;
            let isDisabled = false;
            let columnValueData = null;
            let clickHandler = null;

            if (columnDataType === "link") {
                if (columnId === "quoteId" && quote.quoteId) {
                    columnValue = quote.quoteId;
                    linkDestination = '/quotes/direct-customer/quote-detail/' + quote.quoteId;
                }
            }
            else if (columnDataType === "string") {
                if (columnId === "quoteCreationDate") {
                    columnValue = getDateWithSpecificFormat(quote.createdDate);
                }
                else if (columnId === "derivedCtQuoteId") {
                    columnValue = quote.derivedCtQuoteId || "";
                }
                else if (columnId === "orderType") {
                    columnValue = getOrderTypeText(quote.orderType) || "";
                }
                else if (columnId === "country") {
                    columnValue = quote.countryCode ? getCountryNameByCountryCode(quote.countryCode) : "";
                }
                else if (columnId === "companyName") {
                    columnValue = quote.company || "";
                }
                else if (columnId === "legalEntityName") {
                    columnValue = quote.legalEntity || "";
                }
                else if (columnId === "collectionCity") {
                    columnValue = quote.orderType == '2' ? '-' : (quote.collectionCity || "");
                }
                else if (columnId === "status") {
                    columnValue = getStatusDescriptionFromStatusValue(quote.status) || "";
                }                
                else if (column.id === "vendorName") {
                    columnValue = quote.vendorName || "";
                }
                else if (column.id === "priceUploadedDate") {
                    columnValue = getDateWithSpecificFormat(quote.priceUploadedDate) || "";
                }
                else if (columnId === "quantityOfAssets") {
                    columnValue = quote.assetQty || "";
                }
                else if (column.id === "currency") {
                    columnValue = quote.currencyCode || "";
                }
                else if (columnId === "quotedNetValue") {
                    columnValue = !isNaN(quote.cnetValue) ? quote.cnetValue?.toFixed(2) : "";
                }
                else if (columnId === "quotedHWBuybackValue") {
                    columnValue = !isNaN(quote.chwBuyBackValue) ? quote.chwBuyBackValue?.toFixed(2) : "";
                }
                else if (columnId === "quotedServiceCosts") {
                    columnValue = !isNaN(quote.cserviceCost) ? quote.cserviceCost?.toFixed(2) : "";
                }
                else if (columnId === "vendorQuotedNetValue") {
                    columnValue = quote.vnetValue !== null ? quote.vnetValue : "";
                }
                else if (columnId === "vendorQuotedHWBuybackValue") {
                    columnValue = quote.vhwBuyBackValue !== null ? quote.vhwBuyBackValue : "";
                }
                else if (columnId === "vendorQuotedServiceCosts") {
                    columnValue = quote.vserviceCost !== null ? quote.vserviceCost : "";
                }
                else if (columnId === "hpQuotedHWBuybackValue") {
                    columnValue = quote?.vhpquotedHWBuybackValue?.toFixed(2) || "";
                    quote.revitalizeQuote === "NO" ? isDisabled = true : isDisabled = false;
                }
                else if (columnId === "vendorQuotedRevitalizeFees") {
                    columnValue = quote?.vhardwareRevitalizeFees?.toFixed(2) || "";
                    quote.revitalizeQuote === "NO" ? isDisabled = true : isDisabled = false;
                }
                else if (columnId === "revitalizeQuote") {
                    columnValue = quote.revitalizeQuote !== null ? quote.revitalizeQuote : "";
                    quote.revitalizeQuote === "NO" ? isDisabled = true : isDisabled = false;
                }
                else if (columnId === "quantityofHpRevitalizeAssetsQuoted") {
                    columnValue = quote.numberOfRevitalizeAssets !== null ? quote.numberOfRevitalizeAssets : "";
                    quote.revitalizeQuote === "NO" ? isDisabled = true : isDisabled = false;
                }
            }
            else if (columnDataType === "select") {
                if (columnId === "revitalizeHpPricesStatus") {
                    columnValue = getStatusDescriptionFromStatusValue(quote.hpRevDirStatus) || '';
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    isDisabled = true;
                    if (quote.revitalizeQuote === 'YES') {
                        if (quote.hpRevDirStatus === 'PENDING') {
                            isDisabled = false;
                            columnValueData.options = [{ id: quote.hpRevDirStatus, label: columnValue }, ...revitalizeHPPricesPendingOptions]
                        } else if (quote.hpRevDirStatus === 'REQUESTED') {
                            isDisabled = false;
                            columnValueData.options = [{ id: "REQUESTED", label: "Requested" }]
                        } else if (quote.hpRevDirStatus === 'PROVIDED') {
                            columnValueData.options = [{ id: "PROVIDED", label: "Provided" }]
                        }
                        clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null
                    }
                }
            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValueData || columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    disabled: isDisabled,
                    linkDestination: linkDestination,
                    clickHandler: clickHandler
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
